import { AxiosResponse, CancelToken } from "axios";
import http from "../../../../shared/http";
import { ReadActivitiesRequestDto, ReadActivitiesResponseDto } from "./dtos";

export const listActivities = async (
  { _query }: ReadActivitiesRequestDto,
  cancelToken: CancelToken
): Promise<AxiosResponse<ReadActivitiesResponseDto>> => {
  return await http.post<ReadActivitiesResponseDto>(`/activities`, _query, {
    cancelToken,
  });
};
